import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';

const Cancel: React.FC = () => {
  const navigate = useNavigate();

  const handleRetryPayment = () => {
    navigate('/checkout');
  };

  const handleContinueShopping = () => {
    navigate('/shop');
  };

  return (
    <div className="cancel-container">
      <div className="cancel-content">
        <div className="cancel-icon">❌</div>
        <h1>Payment Cancelled</h1>
        <p>Your payment was not completed. No charges have been made to your account.</p>
        
        <div className="cancel-actions">
          <button onClick={handleRetryPayment} className="retry-btn">
            Try Again
          </button>
          <button onClick={handleContinueShopping} className="shop-btn">
            Continue Shopping
          </button>
        </div>
        
        <div className="help-section">
          <h3>Need Help?</h3>
          <p>If you're experiencing issues with payment, please contact us:</p>
          <ul>
            <li>📧 Email: support@hogcloud.net</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Cancel; 